import { isMotionReduced } from '#src/app/shared/utils/accessibility';

export const scrollToContent = (id: string) =>
	document.getElementById(id)?.scrollIntoView({ behavior: isMotionReduced() ? 'auto' : 'smooth' });
